module.exports = __webpack_public_path__ + "static/youth-girls-3ec63f54f1352c80c74f8a8866a3bfc2.jpg";